/**
 * Patient table column configuration - responsive design
 */

import { ColumnConfig } from '../hooks/useTablePreferences';

export const patientColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'email',
    label: 'Email',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    defaultWidth: 100,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'age',
    label: 'Age',
    defaultWidth: 60,
    minWidth: 50,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'status',
    label: 'Status',
    defaultWidth: 80,
    minWidth: 70,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'lastMeeting',
    label: 'Last Meeting',
    defaultWidth: 100,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'nextMeeting',
    label: 'Next Meeting',
    defaultWidth: 100,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  // Hidden by default - available via Manage Columns
  {
    key: 'idNumber',
    label: 'ID Number',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'clinicName',
    label: 'Clinic',
    defaultWidth: 140,
    minWidth: 110,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'referralName',
    label: 'Referral',
    defaultWidth: 140,
    minWidth: 110,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'hmId',
    label: 'HM ID',
    defaultWidth: 85,
    minWidth: 75,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'gender',
    label: 'Gender',
    defaultWidth: 70,
    minWidth: 60,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'startMedication',
    label: 'Start Medication',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 100,
    minWidth: 90,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'updatedAt',
    label: 'Updated',
    defaultWidth: 100,
    minWidth: 90,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'titrationStatus',
    label: 'Titration Status',
    defaultWidth: 130,
    minWidth: 110,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'titrationMeasurementStatus',
    label: 'Titration Measurement Status',
    defaultWidth: 180,
    minWidth: 120,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'titrationMeasurementApprovalStatus',
    label: 'Titration Measurement Approval Status',
    defaultWidth: 220,
    minWidth: 130,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'medicationMonitoringStatus',
    label: 'Medication Monitoring Status',
    defaultWidth: 200,
    minWidth: 130,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'treatmentStatus',
    label: 'Treatment Status',
    defaultWidth: 140,
    minWidth: 110,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'doctor',
    label: 'Doctor',
    defaultWidth: 140,
    minWidth: 120,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'caseManager',
    label: 'Case Manager',
    defaultWidth: 140,
    minWidth: 120,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'nursePrescriber',
    label: 'Nurse Prescriber',
    defaultWidth: 140,
    minWidth: 120,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'nextMeetingType',
    label: 'Next Meeting Type',
    defaultWidth: 140,
    minWidth: 120,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'finishReason',
    label: 'Finish Reason',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'finishNotes',
    label: 'Finish Notes',
    defaultWidth: 150,
    minWidth: 130,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'isTest',
    label: 'Test',
    defaultWidth: 60,
    minWidth: 50,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
